import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-129" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-130" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-extrabold text-brand-blue md:text-4xl" data-id="element-131" data-mp="2wmyegiul7n80">🎨 Ti Riconosci in Queste Situazioni?</h2>
        <p className="mt-4 text-brand-gray" data-id="element-132" data-mp="35ppvcy68fb71">
          Non sei solo/a. La maggior parte degli insegnanti di arte vive esattamente questo.
        </p>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-133" data-mp="30pv2ip2wcbjc">
          {painPoints.map(({
          title,
          description
        }, index) => <article key={title} className="flex flex-col rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-6 text-left shadow-sm" data-id="element-134" data-mp="3ferc4qklpwm2" data-mpi={index}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-blue font-display text-sm font-bold text-white" data-id="element-135" data-mp="3ogqqfb48emlb">
                {index + 1}
              </span>
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-blue" data-id="element-136" data-mp="sw3137p4e40e">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-137" data-mp="wx4s518vv9ra">{description}</p>
            </article>)}
        </div>
        <p className="mt-12 font-display text-2xl font-bold italic text-brand-red" data-id="element-138" data-mp="11xiz0fyr0dnq">E meriti molto di più di questo.</p>
      </Reveal>
    </section>;
}